export default {
  add: 'Pridať službu',
  ambulance: 'Ambulancia',
  hotel: 'Ubytovanie',
  salon: 'Salón',
  service: 'Služba | Služby',
  shelter: 'Útulok',
  trainer: 'Tréning',
  walking: 'Venčenie'
}



// WEBPACK FOOTER //
// ./src/i18n/sk/routes/services.js